import { useEffect, useState } from 'react'

import { useAsyncCallback } from '../../../../hooks'
import {
  getDocFlowSendingActiveWidget,
  getDocFlowSendingWidgetProcess,
  updateDocFlowSendingFileProcess,
} from '../../DocFlowSending'
import { useDocFlowContext } from '../useDocFlowContext'

export function useDocFlowSendingFileProcess({ setActiveWidget }) {
  const { documentId } = useDocFlowContext()

  const [processData, setProcessData] = useState(null)
  const [isProcessDataLoading, setProcessDataLoading] = useState(null)
  const [isProcessDataInitiated, setProcessDataInitiated] = useState(null)

  const getFileProcess = useAsyncCallback(() => {
    setProcessDataLoading(true)

    return getDocFlowSendingWidgetProcess(documentId)
      .then(({ data }) => {
        setProcessData(data)

        setActiveWidget(getDocFlowSendingActiveWidget(data))

        return data
      })
      .finally(() => {
        setProcessDataLoading(false)
      })
  }, [documentId])

  const handleUpdateFileProcess = useAsyncCallback(
    data => {
      setProcessDataLoading(true)

      return updateDocFlowSendingFileProcess({
        data,
        id: documentId,
      })
        .then(response => {
          setProcessData(response.data)

          setActiveWidget(getDocFlowSendingActiveWidget(response.data))

          return response.data
        })
        .finally(() => {
          setProcessDataLoading(false)
        })
    },
    [documentId]
  )

  useEffect(() => {
    getFileProcess().finally(() => {
      setProcessDataInitiated(true)
    })
  }, [])

  return {
    getFileProcess,
    handleUpdateFileProcess,
    isProcessDataInitiated,
    isProcessDataLoading,
    processData,
    setProcessData,
    setProcessDataLoading,
  }
}
